"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  PROJECTS: 'projects',
  SHOOTSTAGRAD: 'shootstacolour',
  VIDEO: 'video',
  GHOST: 'ghost'
};
exports["default"] = _default;